import { createContext, useState, ReactNode, useContext } from 'react';

interface SelectComponentProviderProps {
  children: ReactNode;
}

interface SelectContextProps {
  selectedOptions: string;
  selectedCredorOption: string;
  onOptionSelected: (value: string, isCredor?: boolean) => void;
}

const SelectComponentContext = createContext<SelectContextProps>(
  {} as SelectContextProps,
);

export const SelectComponentProvider = ({
  children,
}: SelectComponentProviderProps) => {
  const [selectedOptions, setSelectedOptions] = useState<string>('');
  const [selectedCredorOption, setSelectedCredorOption] = useState<string>(
    'Todos' || 0,
  );

  function onOptionSelected(value: string, isCredor?: boolean) {
    if (isCredor) {
      setSelectedCredorOption(value);
    } else {
      setSelectedOptions(value);
    }
  }

  return (
    <SelectComponentContext.Provider
      value={{ selectedOptions, onOptionSelected, selectedCredorOption }}
    >
      {children}
    </SelectComponentContext.Provider>
  );
};

export const useSelectComponent = () => useContext(SelectComponentContext);
